<template>
  <div class="platform-upload-wrap">
    <StaticUploadModeNav v-model="platform" style="margin-bottom: 20px" />
    <div
      :class="[`upload-form-for-${platform}`, { 'has-contest': !!canJoinContest }]"
      class="upload-form"
    >
      <div class="l">
        <StaticWallpaperUploader
          v-if="platform === 'pc'"
          :resource-id="form.resource_id"
          :paper-url="form.paper_url"
          :preview-jpg="form.preview_jpg"
          :required-width="1920"
          :required-height="1080"
          platform="pc"
          width="710px"
          height="400px"
          @update="onPcWallpaperDataUpdate"
          @error="onWallpaperUploadError"
        />
        <StaticWallpaperUploader
          v-else-if="platform === 'mobile'"
          :resource-id="form.mobile_resource_id"
          :paper-url="form.mobile_paper_url"
          :preview-jpg="form.mobile_preview_jpg"
          :required-width="720"
          :required-height="1280"
          platform="mobile"
          width="281px"
          height="500px"
          @update="onMobileWallpaperDataUpdate"
          @error="onWallpaperUploadError"
        />
        <div
          v-else
          class="all-platform-wrapper"
        >
          <StaticWallpaperUploader
            :resource-id="form.resource_id"
            :paper-url="form.paper_url"
            :preview-jpg="form.preview_jpg"
            :required-width="1920"
            :required-height="1080"
            platform="pc"
            width="500px"
            height="400px"
            @update="onPcWallpaperDataUpdate"
            @error="onWallpaperUploadError"
          />
          <StaticWallpaperUploader
            :resource-id="form.mobile_resource_id"
            :paper-url="form.mobile_paper_url"
            :preview-jpg="form.mobile_preview_jpg"
            :required-width="720"
            :required-height="1280"
            platform="mobile"
            width="158px"
            height="400px"
            @update="onMobileWallpaperDataUpdate"
            @error="onWallpaperUploadError"
          />
        </div>
          <UploadOther
            style="margin-top: 50px;"
            ref="uploadOther"
            :platform="platform"
            :size="30 * 1024 * 1024"
            @change="onPcWallpaperOtherDataUpdate"
            @error="handleError">
          </UploadOther>
      </div>
      <div class="r">
        <div class="row">
          <label>
            <em class="hl">*</em>壁纸名称：
          </label>
          <div class="s">
            <el-input
              v-model="form.wname"
              clearable
              placeholder="合适的名字能让人一见钟情哦"
            />
            <span
              v-if="form.wname && form.wname.length > maxTextLength"
              class="error"
            >壁纸名称最多支持{{ maxTextLength }}个字哦</span>
          </div>
        </div>
        <div class="row">
          <label>
            <em class="hl">*</em>分类：
          </label>
          <div class="s">
            <el-select
              v-model="form.cid"
              placeholder="请选择"
            >
              <el-option
                v-for="item in cateList"
                :key="item.id"
                :label="item.cname"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>
        <div class="row one-row">
          <label>
            <em class="hl">*</em>标签：
          </label>
          <div class="s">
            <el-select
              v-model="tagsInput"
              :remote-method="findTagList"
              allow-create
              default-first-option
              filterable
              multiple
              placeholder="请选择或编辑后按回车键录入"
              remote
            >
              <el-option
                v-for="item in filteredTagList"
                :key="item.tid"
                :label="item.tname"
                :value="item.tname"
              />
            </el-select>
            <span v-if="tagsInput.length < 3" class="tag-tips">至少添加3个标签</span>
            <span v-if="hasTagLengthExceedsLimit" class="error">标签最多支持{{ maxTextLength }}个字哦</span>
          </div>
        </div>
        <div v-if="ckey.reference.length + (ckey.categories[form.cid] ? ckey.categories[form.cid].length : 0) > 0" class="row one-row">
          <span class="tags-label">参考标签：</span>
          <div class="tags">
            <button v-for="tag in ckey.reference" :key="tag.tag" class="tips-tag" :class="[tag.state && 'active']" round @click="clickTipsTag(tag)">
              {{ tag.tag }}
            </button>
            <br>
            <button v-for="tag in ckey.categories[form.cid]" :key="tag.tag" class="tips-tag" :class="[tag.state && 'active']" round @click="clickTipsTag(tag)">
              {{ tag.tag }}
            </button>
          </div>
        </div>
        <div v-if="ckey.contest.length > 0" class="row one-row">
          <span class="tags-label">参与活动：</span>
          <button v-for="tag in ckey.contest" :key="tag.tag" class="tips-tag" :class="[tag.state && 'active']" round @click="clickTipsTag(tag)">
            {{ tag.tag }}
          </button>
        </div>
        <div v-if="canUploadVipPType || canUploadAdPType" class="row one-row">
          <!-- 赞赏类型 -->
          <label>
            <em class="hl">*</em>赞赏类型( 作者可获得壁纸的赞赏收益 )：
            <p
              v-if="canUploadVipPType"
              class="yuanbao-tips"
              @click="showYuanbao = true"
            >
              <i class="icon-qa">?</i>
              赞赏壁纸元宝分成说明
            </p>
          </label>
          <div class="s">
            <el-radio v-if="canUploadVipPType" v-model="form.ptype" :label="PTypes.VIP">
              鱼干/会员赞赏
            </el-radio>
            <el-tooltip v-if="canUploadAdPType" class="item" effect="dark" content="仅手机壁纸支持广告赞赏" placement="top-start">
              <el-radio v-model="form.ptype" :label="PTypes.AD">
                广告赞赏
              </el-radio>
            </el-tooltip>
            <el-radio v-model="form.ptype" :label="PTypes.FREE">
              无需赞赏
            </el-radio>
          </div>
          <div v-if="form.ptype === PTypes.VIP" class="row">
            <label>
              <em class="hl">*</em>赞赏金额（单位：鱼干）
            </label>
            <div class="s">
              <el-select
                v-model="form.price"
                placeholder="请选择价格"
              >
                <el-option
                  v-for="price in priceList"
                  :key="price"
                  :label="price / 100"
                  :value="+price"
                />
              </el-select>
            </div>
          </div>
        </div>
        <!-- 签约 -->
        <div v-if="contractCheck.status" class="row one-row">
          合作
          <!-- 0：不能签约 -->
          <label>
            <em class="hl">*</em>请选择作品合作方式
            <template>
              ( <span class="know-more" @click="showHezuo = true">了解详情</span> )
            </template>
          </label>
          <div class="hezuo">
            <el-radio v-model="form.cooperate_type" :label="1" @change="form.auth_amount = 0">
              普通授权
            </el-radio>
            <el-radio v-model="form.cooperate_type" :label="2" @change="!isContractCheck && (showHezuo = true)">
              有限排他授权
            </el-radio>
            <el-radio v-model="form.cooperate_type" :label="3" @change="!isContractCheck && (showHezuo = true)">
              转让
            </el-radio>
            <!-- 若完成，则展示作品授权金额的填写框。（填写金额在0-1000范围内） -->
            <label v-if="isContractCheck && [2, 3].includes(form.cooperate_type)" class="input">
              授权金额：
              {{ contractCheck.auth_amount / 100 }}
              元
            </label>
          </div>
        </div>
        <template v-if="userInfoFresh.user_type === 0">
          <div class="row one-row">
            <em class="hl">*</em>手机号：
            <el-input v-model="form.phone_number" class="inline-input phone_number" placeholder="请填写11位有效手机号码" clearable />
            <span v-if="!sendSmscodeReady" class="verification" @click="handleSendSmscode">发送验证码</span>
            <span v-else class="verification_down">{{ sendSmscodeReady }}秒重新获取</span>
            <span>
              <em class="hl">*</em>验证码：
            </span>
            <el-input v-model="form.phone_code" class="inline-input phone_code" aria-placeholder="请输入手机验证码" autocomplete="off" />
          </div>
        </template>
        <div class="ctrl one-row">
          <div class="confirm">
            <el-checkbox v-model="treatyChecked">
              我已阅读并同意
            </el-checkbox>
            <a
              href="http://mobile-wallpaper-cdn.zhhainiao.com/mobile/agreement/yuanqiwallpaper-upload-cn.html"
              rel="noopener noreferrer"
              target="_blank"
            >《壁纸上传发布服务使用协议》</a>
          </div>
          <span class="btn-publish" @click="handlePublish">发布</span>
        </div>
      </div>
    </div>
    <div v-if="confirmDialogText || showHezuo || contractCheckWarn || showUpAuthDialog" class="mask" />
    <div
      v-if="confirmDialogText"
      class="confirm-dalog-wrap"
    >
      <ConfirmDialog
        :text="confirmDialogText"
        @close="handleConfirmDialogClose"
      />
    </div>
    <!-- 签约成功后不再弹窗 -->
    <div v-if="showHezuo" class="rule-wrap">
      <HezuoAuthorRule :url="contractCheck.url" :status="contractCheck.status" @close="showHezuo = false" />
    </div>
    <div v-if="contractCheckWarn" class="rule-wrap">
      <HezuoWarn :url="contractCheck.url" @close="contractCheckWarn = false" />
    </div>
    <UpAuthDialog v-model="showUpAuthDialog" class="rule-wrap" is-confirm :now-downloads="userInfoFresh.works_download_cnt + userInfoFresh.works_mobile_download_cnt" />
    <div v-if="confirmDialogText || showYuanbao" class="mask" />
    <div v-if="showYuanbao" class="rule-wrap">
      <YuanbaoAuthorRule @close="showYuanbao = false" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import YuanbaoAuthorRule from '../components/dialog/YuanbaoAuthorRule'
import { PTypes, UserTypes } from '../api/config'
import EventEmit from '@/utils/EventEmit'

import ConfirmDialog from '@/components/dialog/ConfirmDialog'
import StaticUploadModeNav from '@/components/Upload/StaticUploadModeNav.vue'
import StaticWallpaperUploader from '@/components/Upload/StaticWallpaperUploader.vue'
import HezuoAuthorRule from '@/components/dialog/HezuoAuthorRule'
import HezuoWarn from '@/components/dialog/HezuoWarn'
// import { fetchContractCheck } from '@/api/signContract'
import { fetchUserInfo } from '@/api/user'
import UpAuthDialog from '@/components/dialog/upAuthDialog'
import UploadOther from '@/components/Upload/UploadOther.vue'

// import { fetchCkey } from '@/api/config'

import {
  doCommit,
  fetchStaticCateList,
  findStaticTagList,
} from '@/api/upload'

import {
  sendUploadSmscode,
} from '@/api/contractUpload'

const initialForm = {
  wtype: 2, // 0：动态壁纸 ， 1：场景壁纸，2: 静态壁纸
  // cid: 0,
  tags: '',
  wname: '',
  ptype: 0,
  contract: '',
  paper_url: '',
  // resource_id: undefined,
  preview_jpg: '',
  // mobile_resource_id: undefined,
  mobile_wtype: 4, // 3：动态壁纸 (移动端)， 4: 静态壁纸(移动端)
  mobile_paper_url: '',
  mobile_preview_jpg: '',
  cooperate_type: 1,
  phone_number: '',
  phone_code: '',
}

export default {
  name: 'StaticPlatformUpload',
  components: {
    ConfirmDialog,
    StaticUploadModeNav,
    StaticWallpaperUploader,
    HezuoAuthorRule,
    HezuoWarn,
    UpAuthDialog,
    YuanbaoAuthorRule,
    UploadOther
    
  },
  props: {
    queryPlatform: {
      type: String,
      default: 'pc',
    },
  },
  data() {
    return {
      sendSmscodeReady: 0,
      UserTypes,
      PTypes,
      platform: this.queryPlatform,
      fileMaxSize: 10 * 1024 * 1024, // 10M
      form: Object.assign({}, initialForm),
      maxTextLength: 15,
      confirmDialogText: '',
      showYuanbao: false,
      priceList: [6000, 9000, 11000, 12000, 14000, 16000, 18000, 20000, 22000, 24000, 29000, 32000, 36000, 39000],
      treatyChecked: false,
      cateList: [],
      tagList: [],
      verifyTagsMaxLength: true,
      userInfoFresh: {},
      showHezuo: false,
      contractCheckWarn: false,
      contractCheck: {}, // 签约状态
      isContractCheck: false, // 签约成功
      showUpAuthDialog: false,
      ckey: {
        reference: [],
        categories: [],
        contest: [],
      },
      checkedTagEl: new Map(), // 选中的标签元素
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      common: (state) => {
        return {
          token: state.userInfo.token,
          open_id: state.userInfo.open_id,
        }
      },
      contestConfig: state => state.contestConfig,
    }),
    /**
     * 标签列表 - 用于标签输入组件
    */
    tagsInput: {
      /** @returns {string[]} */
      get() {
        return this.form.tags ? this.form.tags.split(',') : []
      },
      set(list) {
        // const oldList = this.form.tags.split(',')
        // for (const oldTag of oldList) {
        //   if (!list.includes(oldTag)) { // 旧有新无
        //     const target = this.checkedTagEl.get(oldTag)
        //     if (target) {
        //       target.state = !target.state
        //       this.checkedTagEl.delete(oldTag)
        //     }
        //     break
        //   }
        // }
        // for (const newTag of list) {
        //   if (!oldList.includes(newTag)) { // 旧无新有
        //     if (this.ckey.tagMap.has(newTag)) {
        //       this.ckey.tagMap.get(newTag).state = true
        //     }
        //     break
        //   }
        // }
        this.form.tags = list.join(',')
      },
    },
    /** 是否有单个标签长度超出限制 */
    hasTagLengthExceedsLimit() {
      return this.tagsInput.some(tag => tag.length > this.maxTextLength)
    },
    filteredTagList() {
      if (this.contestConfig && this.contestConfig.contest_tag_name && this.contestConfig.period !== 4) {
        return this.tagList.filter(tag => tag.tname !== this.contestConfig.contest_tag_name)
      }
      return this.tagList
    },
    /** 是否能上传付费静态壁纸 */
    canUploadVipPType() {
      // 画师才能上传收费静态壁纸
      return this.userInfoFresh.user_type === UserTypes.PAINTER
    },
    /** 是否能上传广告静态壁纸 */
    canUploadAdPType() {
      // 移动端壁纸且非普通用户才能上传广告静态壁纸
      return this.platform !== 'pc' && this.userInfoFresh.user_type !== UserTypes.NORMAL
    },
    canJoinContest() {
      const { contestConfig, platform } = this
      const availableUserTypes = [UserTypes.BIGUP, UserTypes.PAINTER]
      return availableUserTypes.includes(this.userInfoFresh.user_type) && contestConfig
        && (contestConfig.platform === platform || platform === 'all' || contestConfig.platform === 'all')
    },
  },
  mounted() {
    this.fetchCateList()
    this.findTagList()
    this.fetchUserInfo()
    this.fetchCurrentContestConfig()
    this.fetchContractCheck()
    this.fetchCkey()
  },
  methods: {
    ...mapActions(['fetchCurrentContestConfig']),
        onPcWallpaperOtherDataUpdate(data) {
      this.form.attachment_resource_id = data.resourceId
      this.form.mobile_attachment_resource_id = data.resourceId
    },
     handleError(tips) {
      this.confirmDialogText = tips
    },
    onPcWallpaperDataUpdate(data) {
      this.form.resource_id = data.resource_id
      this.form.paper_url = data.resource_url
      this.form.preview_jpg = data.preview_jpg
    },
    onMobileWallpaperDataUpdate(data) {
      this.form.mobile_resource_id = data.resource_id
      this.form.mobile_paper_url = data.resource_url
      this.form.mobile_preview_jpg = data.preview_jpg
    },
    checkPhoneNumber(phoneNumber) {
      console.log(phoneNumber)
      if (!parseInt(phoneNumber)) {
        return false
      }

      if (phoneNumber.length !== 11) {
        return false
      }

      return true
    },
    smsCountDown() {
      setTimeout(() => {
        if (this.sendSmscodeReady > 0) {
          this.sendSmscodeReady--
          this.smsCountDown()
        }
      }, 1000)
    },
    async handleSendSmscode() {
      if (!this.form.phone_number) {
        this.confirmDialogText = '请输入手机号码'
        return
      }

      if (!this.checkPhoneNumber(this.form.phone_number)) {
        this.confirmDialogText = '请输入正确手机号码'
        return
      }

      this.sendSmscodeReady = 0

      try {
        await sendUploadSmscode({
          common: this.common,
          phone: this.form.phone_number,
        })
        this.sendSmscodeReady = 60
        this.smsCountDown()
      } catch (err) {
        this.sendSmscodeReady = 0
        if (err.resp_common) {
          switch (err.resp_common.ret) {
            case 4901001:
              this.confirmDialogText = '请输入正确手机号码'
              break
            case 5901002:
              this.confirmDialogText = '发送验证码失败'
              break
            case 5001002:
              this.confirmDialogText = '服务器繁忙，请稍后重试'
              break
            default:
              this.confirmDialogText = err.resp_common.msg
          }
        } else {
          this.confirmDialogText = err.message
        }
      }
    },
    verification() {
      if (!this.userInfo.token) {
        EventEmit.$emit('SHOW_LOGIN_DIALOG')
        return false
      }

      if (!this.treatyChecked) {
        this.confirmDialogText = '请阅读并同意用户上传协议'
        return false
      }

      const { platform, form } = this

      if ((platform === 'all' || platform === 'pc') && !form.paper_url) {
        this.confirmDialogText = '请上传电脑静态壁纸'
        return false
      }

      if ((platform === 'all' || platform === 'mobile') && !form.mobile_paper_url) {
        this.confirmDialogText = '请上传移动静态壁纸'
        return false
      }

      if (!form.wname) {
        this.confirmDialogText = '请输入壁纸名称'
        return false
      }

      if (!form.cid) {
        this.confirmDialogText = '请选择壁纸分类'
        return false
      }

      // if (!form.contract && this.userInfoFresh.user_type === 0) {
      //   this.confirmDialogText = '请输入联系方式'
      //   return false
      // }

      if (form.wname.length > this.maxTextLength) {
        this.confirmDialogText = '壁纸名称最多支持15个字哦'
        return false
      }

      if (this.tagsInput.length < 3) {
        this.confirmDialogText = '标签至少添加3个'
        return false
      }

      if (this.tagsInput.length > 10) {
        this.confirmDialogText = '标签最多支持10个'
        return false
      }

      if (this.hasTagLengthExceedsLimit) {
        this.confirmDialogText = '标签最多支持15个字哦'
        return false
      }
      return this.verifyContestTag()
    },
    verifyContestTag() {
      if (this.form.tags.length === 0) {
        this.confirmDialogText = '请选择标签'
        return false
      }

      return true
    },
    clickTipsTag(tag) {
      const HAS_KEY = new RegExp(`(,?)(${tag.tag})(,?)`)
      tag.state = !tag.state
      const isAdd = tag.state
      const isHadKey = HAS_KEY.test(this.form.tags)
      if (isAdd && !isHadKey) {
        this.form.tags += (this.form.tags.length > 0 ? ',' : '') + tag.tag
        this.checkedTagEl.set(tag.tag, tag)
      } else if (!isAdd && isHadKey) {
        this.checkedTagEl.delete(tag.tag)

        this.form.tags = this.form.tags.replace(HAS_KEY, (s, s1, s2, s3) => {
          return s1 === ',' && s3 === ',' ? ',' : ''
        })
      }
    },
    async handlePublish() {
      // 点击【发布】或刷新页面，需识别用户是否完成完成签署步骤
      // 没有签约资格 不报签约警告
      // if (!this.isContractCheck && this.contractCheck.status !== 0) {
      //   await this.fetchContractCheck()
      //   if (!this.isContractCheck) {
      //     this.contractCheckWarn = true
      //   }
      //   // 还未签约成功 不能提交
      //   // 刚刚签约成功 展示作品授权金额的填写框
      //   return
      // }

      console.log(this.form)
      if (!this.verification()) {
        return
      }

      try {
        const { platform, form } = this
        if (this.userInfoFresh.user_type === 0) {
          if ((!form.phone_number) || !this.checkPhoneNumber(form.phone_number)) {
            this.confirmDialogText = '请正确手机号码'
            return
          }

          if (!form.phone_code) {
            this.confirmDialogText = '请输入验证码'
            return
          }
        }

        // to make server side happy
        form.phone = form.phone_number
        form.phone_verify_code = form.phone_code
        if (platform === 'pc' && form.mobile_paper_url) {
          form.mobile_paper_url = ''
          form.mobile_resource_id = undefined
          form.mobile_preview_jpg = ''
        } else if (platform === 'mobile' && form.paper_url) {
          form.paper_url = ''
          form.resource_id = undefined
          form.preview_jpg = ''
        }

        const data = Object.assign(
          {
            common: this.common,
            ptype: 0, // 付费类型，0：免费，1：付费
          },
          this.form,
        )
        const res = await doCommit(data)
        if (res.resp_common && !res.resp_common.ret) {
          this.sendSmscodeReady = 0
          this.confirmDialogText
            = '发布成功，壁纸进入审核流程，<br/>审核结果将通过元气壁纸消息中心通知您哦'
          this.hasFormSubmitted = true
          this.$refs.uploadOther && this.$refs.uploadOther.handleRemoveVideoResource()
          this.checkedTagEl.forEach((val, key) => {
            val.state = !val.state
          })
          this.checkedTagEl.clear()
        }
      } catch (err) {
        if (err.resp_common) {
          if ([4911031, 4911024].includes(err.resp_common.ret)) {
            this.showUpAuthDialog = true
          } else if ([4901003, 4901002].includes(err.resp_common.ret)) {
            this.confirmDialogText = '验证码错误'
          } else {
            this.confirmDialogText = err.resp_common.msg
          }
          return
        }

        this.confirmDialogText = err.message
      }
    },
    handleConfirmDialogClose() {
      if (this.hasFormSubmitted) {
        this.form = Object.assign({}, initialForm)
        this.hasFormSubmitted = false
      }
      this.confirmDialogText = ''
    },
    checkTagsMaxLength() {
      if (this.form.tags.length === 0) {
        return false
      }

      for (let i = 0, len = this.form.tags.length; i < len; i++) {
        const item = this.form.tags[i]
        if (item.length > this.maxTextLength) {
          return false
        }
      }

      return true
    },
    async fetchCateList() {
      const res = await fetchStaticCateList({
        size: 1000,
      })

      if (res && res.data) {
        this.cateList = res.data
      }
    },
    async findTagList(query = '') {
      const res = await findStaticTagList({
        kw: query,
        count: 20,
      })

      if (res && res.data) {
        this.tagList = res.data
      }
    },
    onWallpaperUploadError(errorMsg) {
      this.confirmDialogText = errorMsg
    },
    async fetchUserInfo() {
      if (!this.common.token) {
        this.userInfoFresh = {}
        return
      }
      try {
        const res = await fetchUserInfo({
          common: this.common,
        })

        if (res && res.resp_common && !res.resp_common.ret) {
          this.userInfoFresh = res.user_info
        }
      } catch (err) {
        //
      }
    },
    async fetchContractCheck() {
      // const res = await fetchContractCheck()
      // this.contractCheck = res.data
      // this.isContractCheck = res.data.status === 7 // 签约成功
    },
    async fetchCkey() {
      // const data = await fetchCkey('wallpaper_live_tags')
      // const tagMap = new Map()
      // const unrepeatKeys = (list) => Array.from(new Set(list)).map(tag => {
      //   const obj = { tag, state: false }
      //   tagMap.set(tag, obj)
      //   return obj
      // })
      // this.ckey = {
      //   reference: unrepeatKeys(data.reference.tags),
      //   categories: data.categories.reduce((prev, next) => {
      //     prev[next.cid] = unrepeatKeys(next.tags)
      //     return prev
      //   }, {}),
      //   contest: unrepeatKeys(data.contest.reduce((prev, next) => {
      //     const startTime = new Date(next.start_time)
      //     const endTime = new Date(next.end_time)
      //     const now = Date.now()
      //     if (startTime < now && now < endTime) {
      //       prev.push(next.tag)
      //     }
      //     return prev
      //   }, [])),
      //   tagMap,
      // }
    },
  },
}
</script>

<style lang="scss" scoped>
.tag-tips {
  position: absolute;
  top: 50px;
  right: 30px;
  color: #A5A5AE;
  font-size: 14px;
}
.tips-tag {
  background: #FFFFFF;
  border: 1px solid #CCCCCC;
  border-radius: 13px;
  color: #A5A5AE;
  font-size: 12px;
  padding: 8px 15px;
  cursor: pointer;
  margin-right: 10px;
  margin-bottom: 8px;
  &:hover {
    border: 1px solid #F4C000;
    color: #03040A;
  }
  &.active {
    border: 1px solid #F4C000;
    background: #F4C000;
    color: #03040A;
  }
}
.tags-label {
  width: 90px;
  line-height: 30px;
  float: left;
}
.tags {
  width: calc(100% - 100px);
  float: left;
}
.platform-upload-wrap {
  width: 1200px;
  margin: 0 auto;
  padding: 13px 0 15px;
  background: #FFFFFF;
  border-radius: 10px;
}

.upload-form {
  padding-bottom: 20px;
  .l {
    width: 710px;
    padding: 15px 40px;
    margin: 0 auto;
  }
  a {
    color: #E88E01;
  }
  .sub {
    color: #999;
    font-size: 12px;
  }
}

.upload-form-for-mobile {
  .l {
    width: 650px;
  }
}

.upload-form-for-all {
  flex-wrap: wrap;
  .l, .r {
    width: 678px;
    margin: 0 auto;
  }
}

.all-platform-wrapper {
  display: flex;
}

.r {
  display: grid;
  grid-template-columns: 50% 50%;
  margin: 0 auto;
  width: 710px;
  padding-top: 15px;
  label {
    display: block;
    margin: 10px 0 10px;
    font-size: 16px;
    color: #333;
  }
  .poster-label {
    margin: 0;
    &::after {
      content: '';
      display: table;
      clear: both;
    }
    .txt {
      float: left;
      margin-top: 5px;
    }
    .btn-poster-upload {
      float: right;
    }
  }
}

.row {
  position: relative;
  padding: 0 12px;
  margin-bottom: 10px;
  .el-radio,
  .el-checkbox {
    text-align: left;
  }
  .hl {
    font-style: normal;
    color: #f41c83;
  }
  .error {
    font-style: normal;
    font-size: 12px;
    color: #f41c83;
  }
  label {
    position: relative;
    .hl {
      position: absolute;
      left: -12px;
      top: 3px;
    }
  }
  ::v-deep {
    .el-radio {
      display: inline-block;
      margin-right: 30px;
    }
  }
}

.ctrl {
  padding-top: 28px;
  text-align: left;
  padding-left: 12px;
  .btn-publish {
    display: inline-block;
    width: 240px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    background: #f5b903;
    border-radius: 8px;
    color: #333;
    cursor: pointer;
  }
}

.confirm {
  // text-align: center;
  font-size: 12px;
  label {
    display: inline-block;
  }
  a {
    margin-left: 5px;
    text-decoration: underline;
    color: #E88E01;
  }
}

.el-select {
  display: block;
}
.one-row {
  /** 整行 */
  grid-column: 1 / 3;
}
.yuanbao-tips {
  display: inline-block;
  font-size: 12px;
  color: #e88e01;
  cursor: pointer;
  .icon-qa {
    display: inline-block;
    width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    font-size: 10px;
    font-style: normal;
    background: #e7e7e7;
    border-radius: 50%;
    color: #333;
  }
}
.rule-wrap {
  z-index: 8;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.mask {
  z-index: 7;
  top: 0;
  left: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.5);
}
.hezuo {
  display: flex;
  align-content: center;
  .input {
    font-size: 14px;
  }
}
.rule-wrap {
  z-index: 8;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.know-more {
  cursor: pointer;
  text-decoration: underline;
  color: #E88E01;
}
.flex {
  display: flex;
}
.inline-input {
  display: inline-block;
}

.phone_number {
  width: 250px;
}
.phone_code {
  width: 100px;
}

.phone_code_input {
  display: inline-block;
  width: 100px;
}

.verification {
  display: inline-block;
  width: 100px;
  height: 35px;
  margin: 0 15px;
  line-height: 35px;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  background: #f5b903;
  border-radius: 8px;
  color: #333;
  cursor: pointer;
}

.verification_down {
  display: inline-block;
  width: 100px;
  height: 35px;
  margin: 0 15px;
  line-height: 35px;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  background: #e7e7e7;
  border-radius: 8px;
  color: #333;
  cursor: pointer;
}
</style>
